<template lang="pug">
  .bargraph
    .bargraph_svgwrapper(ref="svgwrapper")
</template>
<script>
  import {mapState, mapActions} from 'vuex';
  import * as d3 from 'd3';
  import _ from 'lodash';

  export default {
    data: function(){
      return {
        svg: undefined,
        bars: undefined,
        axis: undefined,
        scale: {
          x: undefined,
          y: undefined
        },
        yaxis: undefined,
        offset: {
          left: 46,
          right: 46,
          bottom: 70,
          top: 80

        },
        gutter: 5
      }
    },
    computed: {
      ...mapState([
        'lang',
        'size',
        'map',
        'selected',
        'legend',
        'update_time',
      ]),
      is_ja(){
        return /ja/.test(this.lang)
      }
    },
    mounted(){
      //console.log( this );
      this.make_svg();
      this.add_axis();
      this.add_bar_group();
    },
    watch: {
      'update_time': function(val, oldVal){
        this.set_scale();
        if( oldVal > 0){
          this.update_graph();
        }else{
          this.draw_graph();
        }
      },
      'size.timestamp': function(){
        //resize
        this.set_scale();
        this.update_graph();
      }
    },
    methods: {
      ...mapActions([
        'changeMode',
        'modifyLocations',
      ]),
      /**
       * Handler
       * 折れ線グラフのパネルを表示するためのイベントハンドラ。バブリングが目的
       */
      openLinegraph: function(location){
        this.changeMode('linegraph');
        this.modifyLocations([0, location]);
      },

      make_svg(){
        //console.log( 'make_svg' );
        this.svg = d3.select(this.$refs.svgwrapper)
          .append('svg')
          .attr('class', 'bargraph_svg')

      },
      add_axis(){
        this.axis = this.svg
          .append('g')
          .classed('bargraph_axis', true)
          .attr('transform', 'translate(' + 0 + ',' +this.offset.top + ')')
        this.yaxis = d3.axisLeft()
      },
      add_bar_group(){
        this.bars = this.svg.append('g')
          .classed('bargraph_bars', true)
          .attr('transform', 'translate(' + this.offset.left + ', ' +  this.offset.top + ')')
      },
      get_grapharea_width(){
        //let cw = $(this.$refs.svgwrapper).width();
        let cw = this.size.svg.width;
        return cw - this.offset.left - this.offset.right;
      },
      get_grapharea_height(){
        //let ch = $(this.$refs.svgwrapper).height();
        const ch = this.size.svg.height;
        return ch - this.offset.top - this.offset.bottom;
      },
      get_bar_width(){
        let cw = this.get_grapharea_width();
        return cw / ( this.map.features.length - 1)
      },
      get_adjustmentY(){
        const features = this.map.features;
        let maxY = d3.max(features, (d) => Math.floor(d.api_data.value))
        let digits = Math.pow(10, Math.min(4, String(maxY).length) - 1);
        let tmpY = maxY / digits;
        let ceilY = Math.ceil(tmpY);
        let adjustmentY = Math.max(ceilY * digits, 100);
        return adjustmentY;
      },
      set_scale(){
        let cw = this.get_grapharea_width();
        let ch = this.get_grapharea_height();

        const features = this.map.features;
        this.scale.x = d3.scaleLinear()
          .domain([0, features.length - 1])
          .range([0, cw - this.get_bar_width()])

        let adjustmentY = this.get_adjustmentY();

        this.scale.y = d3.scaleLinear()
          .domain([0, adjustmentY])
          .range([ch, 0])

      },
      /**
       * 棒グラフを初期生成する
       */
      draw_graph(){
        let bar_group = this.bars
          .selectAll('g')
          .data(this.map.features)
          .enter()
          .append('g')
          .classed('bargraph_bargroup', true)
          .attr('transform', (d) => {
            return 'translate(' + this.scale.x(d.api_data.rank - 1) + ', 0)';
          })
          .on('click', (d) => {
            //console.log('click', d.properties.name);
            this.openLinegraph(d.properties.name);
          })


        let barhover = bar_group.append('g')
          .classed('bargraph_barhover', true)
          .attr('transform', 'translate(0, ' + (-this.offset.top + 20)+ ')')

        /* **********************************************
         *
         * bar info pole
         *
         *********************************************** */

        let barpole = barhover.append('g')
          .classed('bargraph_pole', true)
          .attr('transform', 'translate(' + ((this.get_bar_width() - this.gutter) / 2) + ', 0)')

        barpole.append('line')
          .classed('bargraph_poleline', true)
          .attr('x1', 0)
          .attr('y1', 0)
          .attr('x2', 0)
          .attr('y2', this.get_grapharea_height() + (this.offset.top - 20))
          .attr('stroke', '#000')
          .attr('stroke-width', 1)


        barpole.append('circle')
          .classed('bargraph_polehead', true)
          .attr('cx', 0)
          .attr('cy', 0)
          .attr('r', 2)
          .attr('fill', '#000')


        /* **********************************************
         *
         * bar info
         *
         *********************************************** */

        let barinfo = barhover.append('g')
          .classed('bargraph_info', true)
          .attr('transform', 'translate( -10 , 36)')

        barinfo.append('text')
          .classed('bargraph_infovalue', true)
          .text((d) => {
            const trancate_digit = (this.selected.type.value == 'Life_expectancy' || this.selected.type.value == 'HALE') ? 10 : 1000;
            return Math.floor( d.api_data.value  * trancate_digit) / trancate_digit;
          })
          .attr('y', 0)

        barinfo.append('text')
          .classed('bargraph_infotype', true)
          .text(() => {
            return /ja/.test(this.lang) ? this.selected.type.name : this.selected.type.label;
          })
          .attr('y', 17)

        barinfo.append('text')
          .classed('bargraph_infolocation', true)
          .text((d) => {
            return /ja/.test(this.lang) ? d.properties.name_local : d.properties.name;
          })
          .attr('y', 50)

        // rect のサイズは、 update_graph()内で行われる
        barinfo.append('rect')
          .classed('bargraph_infocolor', true)
          .attr('fill',(d) => {
            return '#' + this.legend[d.api_data.rankgroup];
          })
          .attr('y', 21)




        /* **********************************************
         *
         * bar
         *
         *********************************************** */
        bar_group.append('rect')
          .classed('bargraph_bar', true)
          .attr('y', () => {
            return this.scale.y(0)
          })
          .attr('width', () => {
            return this.get_bar_width() - this.gutter
          })
          .attr('height', () => {
            this.get_grapharea_height()
            return 0
          })
          .attr('fill', (d) => {
            return '#' + this.legend[d.api_data.rankgroup];
          })

        /* **********************************************
         *
         * bar location text
         *
         *********************************************** */

        bar_group.append('g')
          .classed('bargraph_textwrapper', true)
          .attr('transform', () => {
            return 'translate(' + (this.get_bar_width() / 2)  + ', ' + (this.get_grapharea_height() + 4 ) + ')'
          })
          .append('text')
          .attr('transform', 'rotate(-45)')
          .classed('bargraph_location', true)
          .text((d) => {
            return this.is_ja ? d.properties.name_local : d.properties.name;
          })
          .attr('fill', (d) => {
            return '#' + this.legend[d.api_data.rankgroup];
          })

        this.axis
          .call(this.yaxis
            .scale(this.scale.y)
            .tickSizeInner(-this.size.svg.width)
          )

        this.update_graph();
      },

      /**
       * 棒グラフの更新を行う
       */
      update_graph(){
        let bar_group = this.bars
          .selectAll('g.bargraph_bargroup')
          .data(this.map.features)
          .transition()
          .duration(500)
          .attr('transform', (d) => {
            return 'translate(' + this.scale.x(d.api_data.rank - 1) + ', 0)';
          })


        let barhover = bar_group.selectAll('g.bargraph_barhover')

        /* **********************************************
         *
         * bar info pole
         *
         *********************************************** */

        let barpole = barhover.selectAll('g.bargraph_pole')
          .attr('transform', 'translate(' + ((this.get_bar_width() - this.gutter) / 2) + ', 0)')


        barpole.selectAll('line.bargraph_poleline')
          .attr('y2', this.get_grapharea_height() + (this.offset.top - 20))


        /* **********************************************
         *
         * bar info
         *
         *********************************************** */

        let barinfo = barhover.selectAll('g.bargraph_info')
          .attr('transform', (d) => {
            let dx = d.api_data.rankgroup <= 1 ? (this.get_bar_width() - this.gutter) : 0
            return 'translate(' + dx + ', 36)'
          })

        let infovalue = barinfo.selectAll('text.bargraph_infovalue')
          .text((d) => {
            const trancate_digit = (this.selected.type.value == 'Life_expectancy' || this.selected.type.value == 'HALE') ? 10 : 1000;
            return Math.floor( d.api_data.value  * trancate_digit) / trancate_digit;
          })
          .selection()
          .classed('bargraph_infovalue-overflow', (d) => {
            return d.api_data.rankgroup <= 1;
          })

        let infotype = barinfo.selectAll('text.bargraph_infotype')
          .text(() => {
            return /ja/.test(this.lang) ? this.selected.type.name : this.selected.type.label;
          })
          .selection()
          .classed('bargraph_infotype-overflow', (d) => {
            return d.api_data.rankgroup <= 1;
          })

        let infolocation = barinfo.selectAll('text.bargraph_infolocation')
          .selection()
          .classed('bargraph_infolocation-overflow', (d) => {
            return d.api_data.rankgroup <= 1;
          });

        // infocolorをテキストの長さに合わせたいが、テキストの代入がアロー関数内にあるせいか、実際に実行されるタイミングが少しずれるっぽい。
        // なので、setTimoutで、実行キューの最後に幅計算を行なうようにする
        setTimeout(() => {
          let maxWidthText = _.maxBy([infovalue, infotype, infolocation], (o) => {
            //console.log(' get max width: ', o, o.node());
            let bbox = o.node().getBBox();
            //console.log( 'get max width:', bbox, bbox.width);
            return bbox.width;
          })

          barinfo.selectAll('rect.bargraph_infocolor')
            .attr('fill',(d) => {
              return '#' + this.legend[d.api_data.rankgroup];
            })
            .attr('x', (d) => {
              return d.api_data.rankgroup <= 1 ? 0 : -maxWidthText.node().getBBox().width;
            })
            .attr('height', '4px')
            .attr('width', maxWidthText.node().getBBox().width);
        }, 0)




        /* **********************************************
         *
         * bar
         *
         *********************************************** */
        bar_group.selectAll('rect.bargraph_bar')
          //.transition()
          .attr('y', (d) => {
            return this.scale.y(d.api_data.value)
          })
          .attr('width', () => {
            return this.get_bar_width() - this.gutter
          })
          .attr('height', (d) => {
            let ch = this.get_grapharea_height()
            return ch - this.scale.y(d.api_data.value)
          })
          .attr('fill', (d) => {
            return '#' + this.legend[d.api_data.rankgroup];
          })



        /* **********************************************
         *
         * bar location text
         *
         *********************************************** */

        bar_group.selectAll('g.bargraph_textwrapper')
          .attr('transform', () => {
            return 'translate(' + (this.get_bar_width() / 2)  + ', ' + (this.get_grapharea_height() + 4 ) + ')'
          })
          .selectAll('text')
          //.transition()
          .attr('fill', (d) => {
            return '#' + this.legend[d.api_data.rankgroup];
          })

        this.axis
          .transition()
          .call(this.yaxis
            .scale(this.scale.y)
            .tickSizeInner(-this.size.svg.width)
          )
      }
    }

  }
</script>
<style lang="sass">
  .bargraph
    $this: &
    height: 100%
    &_svgwrapper
      height: 100%
    &_svg
      width: 100%
      height: 100%
    &_bargroup
      &:hover
        #{$this}
          &_barhover
            visibility: visible
          &_bar
            fill: #000
        #{$this}
          &_location
            fill: #000
    &_barhover
      visibility: hidden
    &_bar
      cursor: pointer
    &_infovalue
      font-size: 36px
      font-weight: bold
      text-anchor: end
      alignment-baseline: alphabetic
      &-overflow
        text-anchor: start

    &_infotype
      font-size: 16px
      text-anchor: end
      alignment-baseline: alphabetic
      &-overflow
        text-anchor: start
    &_infocolor
      height: 4px
    &_infolocation
      font-size: 16px
      font-weight: bold
      text-anchor: end
      alignment-baseline: alphabetic
      &-overflow
        text-anchor: start
    &_location
      font-size: 12px
      text-anchor: end
      alignment-baseline: text-before-edge
    &_axis
      .domain
        display: none
      .tick
        line
          stroke: #ccc
        text
          font-size: 10px
          fill: #666666
          transform: translate(5px, -10px)
          text-anchor: start
</style>